import React from 'react'
import { Grid } from '@material-ui/core'
import { Button, Input, SelectAnimalFetchInput } from 'src/components'

import { useFormContext } from 'react-hook-form'
import { useStyles } from './styles'
import { FormattedOption } from 'src/dto/animal.dto'
import { HealthControlForm } from 'src/@types/validations/Animal'

import { formatDateToInputValue } from 'src/utils'

interface AnimalHealthControlProps {
  onpenVaccineModal: () => void
  onpenAnimalHistoricModal: () => void
}

export const AnimalHealthControl: React.FC<AnimalHealthControlProps> = ({
  onpenVaccineModal,
  onpenAnimalHistoricModal
}) => {
  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<HealthControlForm>()

  const styles = useStyles()
  const animalSelected = watch('idAnimal')

  return (
    <div className={styles.inputWithEditToggle}>
      <SelectAnimalFetchInput
        label='Animal'
        selectBy='id'
        showBy={['cdn', 'nome']}
        hidden={['MT', 'VD']}
        value={watch('idAnimal') || ''}
        name='idAnimal'
        error={errors?.idAnimal?.message}
        placeholder='Selecionar animal'
        onChange={(item: FormattedOption) => {
          setValue('idAnimal', item.id)
          clearErrors('idAnimal')
        }}
      />
      <Grid container spacing={3} style={{ marginTop: 8 }}>
        <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
          <Input
            type='date'
            max='2999-12-31'
            label='Data de aplicação'
            id='dataAplicacao'
            error={errors?.dataAplicacao?.message}
            onChange={(value: string) => {
              const newDate = new Date(value).toISOString()
              setValue('dataAplicacao', newDate)
              clearErrors('dataAplicacao')
            }}
            value={formatDateToInputValue(watch('dataAplicacao') || '')}
          />
        </Grid>
        <Grid item xs={12} sm={6} style={{ padding: '0px 12px', display: 'flex', alignItems: 'center' }}>
          <div className={styles.buttonContainer}>
            {animalSelected && (
              <Button outlined className={styles.buttonWrapper} type='button' onClick={onpenAnimalHistoricModal}>
                Histórico de Vacinação
              </Button>
            )}
            <Button className={styles.buttonWrapper} type='button' onClick={onpenVaccineModal}>
              Adicionar medicamentos
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
